const calcium = {
  parameters: [
    {
      name: 'calcium',
      displayName: 'Calcium',
      id: 'calcium',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'deficiency', 'high', 'fault'],
      ranges: [
        {
          color: '#f52d0a',
          description: 'calcium-deficiency',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 2.15,
          upperLimitOperator: '<',
          unit: 'mmol/l',
          interpretation: 'deficiency',
          displayInterpretation: 'Deficiency',
        },
        {
          color: '#1f7359',
          description: 'calcium-normal',
          lowerLimit: 2.15,
          lowerLimitOperator: '>=',
          upperLimit: 2.5,
          upperLimitOperator: '<=',
          unit: 'mmol/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
        },
        {
          color: '#fdad02',
          description: 'calcium-high',
          lowerLimit: 2.5,
          lowerLimitOperator: '>',
          upperLimit: 5,
          upperLimitOperator: '',
          unit: 'mmol/l',
          interpretation: 'high',
          displayInterpretation: 'High',
        },
      ],
    },
  ],
};

export default calcium;
